import { render } from "./WCItemModifierLinkedItems.vue?vue&type=template&id=2ddfbf9f&scoped=true"
import script from "./WCItemModifierLinkedItems.vue?vue&type=script&lang=js"
export * from "./WCItemModifierLinkedItems.vue?vue&type=script&lang=js"

import "./WCItemModifierLinkedItems.vue?vue&type=style&index=0&id=2ddfbf9f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ddfbf9f"]])

export default __exports__